const transformToCloneLocationInput = data => ({
  locationId: data.location.id,
  brandId: data.brand.id,
})

export default transformToCloneLocationInput
